import * as React from 'react';
import { Config } from '../helper';

/**
 * Pathway modal.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {function} props.closeModal
 * @param {function} props.title
 * @param {string} props.text
 *
 * @returns {JSX.Element}
 *
 * @constructor
 */
export default function Modal(props) {
  const {
    isOpen,
    closeModal,
    title = '',
    text = '',
  } = props;

  const dialogRef = React.useRef(null);

  React.useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (isOpen && !dialog.open) {
      dialog.showModal();
    } else if (!isOpen && dialog.open) {
      dialog.close();
    }
  }, [isOpen]);

  return (
    <dialog className='nv-modal nv-modal-cozy' id='nv-modal' ref={dialogRef}>
      <div className='nv-modal-header'>
        <div className='nv-modal-title'>{title ? title : Config.I18n.Modal.Congratulations}</div>
        <div className='nv-modal-close-button' onClick={closeModal}/>
      </div>
      <div className='nv-modal-body'>
        {text ? text : Config.I18n.Modal.CongratulationsText}
      </div>
      <div className='nv-modal-footer'>
        <button className='nv-cta-primary nv-cta-primary--small' onClick={closeModal}>
          {Config.I18n.Modal.Confirm}
        </button>
      </div>
    </dialog>
  );
}
